import React from "react";
import { Mail, Phone, MapPin, Facebook, Instagram, MessageCircle } from "lucide-react";
import styles from "./Footer.module.css";

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* About Section */}
          {/* <div>
            <h3 className={styles.heading}>Paint by Numbers</h3>
            <p className={styles.description}>
              Bringing creativity and relaxation through therapeutic painting
              workshops.
            </p>
          </div> */}

          {/* Contact Information */}
          <div>
            <h3 className={styles.heading}>Contact Us</h3>
            <div className={styles.contactList}>
              <div className={styles.contactItem}>
                <Mail className={styles.icon} />
                <a
                  href="mailto:iciledawastudio@gmail.com"
                  className={styles.link}
                >
                  iciledawastudio@gmail.com
                </a>
              </div>
              <div className={styles.contactItem}>
                <MessageCircle className={styles.icon} />
                <a
                  href="https://wa.me/201299939647"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  01299939647
                </a>
              </div>
              <div className={styles.contactItem}>
                <MapPin className={styles.icon} />
                <span className={styles.text}>
                  {/* 5th Area, Villa 115
                  <br /> */}
                  {/* Sadat City, Egypt */}
                  Egypt
                </span>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className={styles.heading}>Follow Us</h3>
            <div className={styles.socialMedia}>
              {/* <a
                href="https://www.facebook.com/icile.dawa?mibextid=LQQJ4d"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIcon}
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a> */}
              <a
                href="https://www.instagram.com/artsyicile?igshid=OGQ5ZDc2ODk2ZA=="
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIcon}
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.tiktok.com/@artsyicile?_t=8dlbCXyulC1&_r=1"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIcon}
                aria-label="TikTok"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className={styles.copyright}>
          <p>
            &copy; {new Date().getFullYear()} Paint by Numbers. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
